import {
  Scale,
  Gavel,
  HeartHandshake,
  Landmark,
  HardHat,
  FileSignature,
} from "lucide-react";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1687289133469-b2a07a13b78b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwbGF3JTIwZmlybSUyMG9mZmljZXxlbnwwfHx8fDE3ODY2MDM0MTh8MA&ixlib=rb-4.1.0&q=85",
  office:
    "https://images.unsplash.com/photo-1517502884422-41eaead166d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwbGF3JTIwZmlybSUyMG9mZmljZXxlbnwwfHx8fDE3ODY2MDM0MTh8MA&ixlib=rb-4.1.0&q=85",
  gavel: "https://images.unsplash.com/photo-1676181739859-08330dea8999",
  lawyerFemale:
    "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&q=80",
  lawyerMale:
    "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800&q=80",
};

export const CONTACT = {
  alamat: "Jl. Jend. Ahmad Yani No. 47, Kota Tebing Tinggi, Sumatera Utara",
  telepon: ["0857 6774 0877", "0823 7273 7588", "0821 6130 1540"],
  whatsapp: "6285767740877",
  whatsappDisplay: "0857 6774 0877",
  email: "lbh.tebingtinggi@gmail.com",
  jam: "Senin — Jumat, 09.00 — 17.00 WIB",
};

export const STATS = [
  { angka: "10", label: "Tahun Berkarya" },
  { angka: "45+", label: "Perkara Ditangani" },
  { angka: "8", label: "Advokat & Paralegal" },
  { angka: "8", label: "Kabupaten & Kota" },
];

export const SERVICES = [
  {
    id: "pidana",
    nomor: "01",
    judul: "Hukum Pidana",
    icon: Gavel,
    ringkasan:
      "Pendampingan dan pembelaan menyeluruh pada setiap tahap proses pidana — dari penyidikan hingga kasasi.",
    poin: [
      "Pendampingan tersangka & terdakwa di kepolisian, kejaksaan, dan pengadilan",
      "Penasihat hukum korban dan pelapor",
      "Upaya hukum banding, kasasi, dan peninjauan kembali",
      "Pengajuan penangguhan penahanan dan rehabilitasi nama baik",
    ],
  },
  {
    id: "perdata",
    nomor: "02",
    judul: "Hukum Perdata",
    icon: Scale,
    ringkasan:
      "Penyelesaian sengketa perdata dengan strategi litigasi maupun negosiasi yang terukur dan berpihak pada kepentingan klien.",
    poin: [
      "Gugatan wanprestasi dan perbuatan melawan hukum",
      "Sengketa jual beli, utang piutang, dan perbankan",
      "Mediasi dan penyelesaian sengketa di luar pengadilan",
      "Eksekusi putusan pengadilan",
    ],
  },
  {
    id: "keluarga",
    nomor: "03",
    judul: "Hukum Keluarga & Waris",
    icon: HeartHandshake,
    ringkasan:
      "Pendampingan penuh empati untuk perkara keluarga — perceraian, hak asuh, nafkah, hingga pembagian warisan.",
    poin: [
      "Perceraian di Pengadilan Agama dan Pengadilan Negeri",
      "Hak asuh anak (hadhanah) dan nafkah",
      "Pembagian harta bersama (gono-gini) dan waris",
      "Perjanjian perkawinan dan penetapan ahli waris",
    ],
  },
  {
    id: "pertanahan",
    nomor: "04",
    judul: "Pertanahan & Agraria",
    icon: Landmark,
    ringkasan:
      "Perlindungan hak atas tanah masyarakat — sengketa kepemilikan, tumpang tindih sertifikat, hingga ganti rugi.",
    poin: [
      "Sengketa kepemilikan dan batas tanah",
      "Tumpang tindih sertifikat dan pembatalan di PTUN",
      "Pendampingan proses ganti rugi pengadaan tanah",
      "Legalisasi dan pendaftaran tanah di BPN",
    ],
  },
  {
    id: "ketenagakerjaan",
    nomor: "05",
    judul: "Ketenagakerjaan",
    icon: HardHat,
    ringkasan:
      "Membela hak pekerja dan mendampingi perusahaan membangun hubungan industrial yang sehat dan sesuai regulasi.",
    poin: [
      "PHK sepihak, pesangon, dan upah yang tidak dibayar",
      "Perundingan bipartit dan mediasi di Disnaker",
      "Gugatan ke Pengadilan Hubungan Industrial",
      "Penyusunan peraturan perusahaan dan PKB",
    ],
  },
  {
    id: "perusahaan",
    nomor: "06",
    judul: "Hukum Perusahaan & Kontrak",
    icon: FileSignature,
    ringkasan:
      "Fondasi hukum yang kokoh untuk bisnis Anda — pendirian badan usaha, kontrak, hingga kepatuhan regulasi.",
    poin: [
      "Pendirian PT, CV, yayasan, dan perizinan usaha",
      "Penyusunan dan peninjauan kontrak bisnis",
      "Pendampingan transaksi dan due diligence",
      "Kepatuhan regulasi dan restrukturisasi perusahaan",
    ],
  },
];

export const MANIFESTO = [
  {
    nomor: "01",
    judul: "Integritas",
    teks: "Kami tidak menjual janji, kami menjunjung kebenaran. Setiap perkara ditangani dengan kejujuran penuh — tentang peluang, risiko, dan biaya — sejak konsultasi pertama.",
  },
  {
    nomor: "02",
    judul: "Keadilan",
    teks: "Keadilan tidak boleh menjadi barang mewah. Kami berdiri untuk mereka yang lemah posisinya di hadapan hukum, dan memastikan setiap suara didengar di ruang sidang.",
  },
  {
    nomor: "03",
    judul: "Aksesibilitas",
    teks: "Hukum yang baik adalah hukum yang dapat dijangkau. Konsultasi awal tanpa biaya, bahasa yang dipahami masyarakat, dan kehadiran kami hingga pelosok Sumatera.",
  },
  {
    nomor: "04",
    judul: "Kemanusiaan",
    teks: "Di balik setiap berkas perkara ada kehidupan manusia. Kami menangani hukum dengan nurani — karena membela hak berarti membela martabat seseorang.",
  },
];

export const TEAM = [
  {
    id: "agusri-putra",
    nama: "Agusri Putra P. Nasution, S.H",
    peran: "Direktur Eksekutif",
    bio: "Memimpin YLBH Sumatera Timur dan mengarahkan seluruh program bantuan hukum — dari pendampingan di pengadilan hingga advokasi masyarakat di delapan kabupaten dan kota.",
    foto: "/team/agusri.jpg",
    inisial: "AP",
  },
  {
    id: "sarifudin-sinaga",
    nama: "Sarifudin Sinaga",
    peran: "Wakil Direktur",
    bio: "Mengawasi pelaksanaan program dan standar layanan bantuan hukum, serta memimpin koordinasi paralegal di wilayah kerja Sumatera Timur.",
    foto: "/team/sarifudin.jpg",
    inisial: "SS",
  },
  {
    id: "rasidin",
    nama: "Rasidin",
    peran: "Kepala Divisi Litigasi",
    bio: "Mengoordinasikan penanganan perkara pidana dan perdata — mendampingi klien dari tingkat penyidikan hingga persidangan.",
    foto: "/team/rasidin.jpg",
    inisial: "RA",
  },
  {
    id: "romi-sinaga",
    nama: "Romi Uli Dodoma Sinaga, S.H",
    peran: "Kepala Divisi Non-Litigasi",
    bio: "Menangani konsultasi hukum, mediasi, penyusunan dokumen legal, dan legalitas usaha bagi masyarakat serta pelaku UMKM.",
    foto: "/team/romi.jpg",
    inisial: "RS",
  },
  {
    id: "novita-wulandari",
    nama: "Novita Wulandari",
    peran: "Koordinator Bantuan Hukum",
    bio: "Mengelola posko konsultasi gratis dan program bantuan hukum pro bono bagi masyarakat tidak mampu, sesuai UU No. 16 Tahun 2011.",
    foto: "/team/novita.jpg",
    inisial: "NW",
  },
  {
    id: "hendri-manalu",
    nama: "Hendri Saputra Manalu, S.H., M.H",
    peran: "Advokat Senior",
    bio: "Berpengalaman menangani perkara litigasi dan non-litigasi, dengan fokus pada pendampingan hukum masyarakat di wilayah Sumatera Timur.",
    foto: "/team/hendri.jpg",
    inisial: "HM",
  },
  {
    id: "putri-aisyah",
    nama: "Putri Aisyah Sephia, S.Kom",
    peran: "Staf Administrasi & IT",
    bio: "Mengelola administrasi perkara, dokumentasi digital, dan sistem informasi internal YLBH Sumatera Timur.",
    foto: "/team/putri.jpg",
    inisial: "PA",
  },
  {
    id: "anjeli",
    nama: "Anjeli, S.H",
    peran: "Advokat",
    bio: "Menangani pendampingan hukum pidana dan perdata, serta aktif dalam penyuluhan hukum bagi masyarakat.",
    foto: "/team/anjeli.jpg",
    inisial: "AN",
  },
  {
    id: "herda-faisal",
    nama: "Herda Faisal, S.H",
    peran: "Advokat",
    bio: "Fokus pada perkara litigasi dan konsultasi hukum, dengan komitmen membela hak masyarakat tidak mampu.",
    foto: "/team/herda.jpg",
    inisial: "HF",
  },
  {
    id: "arjun-batubara",
    nama: "Arjun Syaleh Batubara",
    peran: "Paralegal",
    bio: "Garda terdepan pendampingan masyarakat di tingkat desa dan kelurahan — dari penyuluhan hukum hingga pendampingan musyawarah warga.",
    foto: "/team/arjun.jpg",
    inisial: "AB",
  },
  {
    id: "kaiko",
    nama: "Kaiko",
    peran: "Paralegal",
    bio: "Mendampingi masyarakat di tingkat desa dan kelurahan — dari penyuluhan hukum hingga pendampingan musyawarah sengketa warga.",
    foto: "/team/kaiko.jpg",
    inisial: "KA",
  },
  {
    id: "anggi-dewi",
    nama: "Anggi Tri Kurnia Dewi, S.H",
    peran: "Advokat",
    bio: "Menangani konsultasi dan pendampingan hukum, dengan komitmen memberikan layanan terbaik yang berorientasi solusi bagi setiap klien.",
    foto: "/team/anggi.jpg",
    inisial: "AD",
  },
];
